import { axiosInstance } from '@/lib/axios';
import { IntegrationsConfigurationModel } from './types';

type Props = {
  companyId: string
}

export function getIntegrationsSettings({ companyId }: Props) {
  return axiosInstance.get<IntegrationsConfigurationModel>(`/api/${companyId}/configuration/integration`);
}
